import React, { useState } from 'react';
import moment from 'moment';
import CollapsiblePanel from '../../../../formInputsV2/CollapsiblePanel';
import { Card, AlwaysOpenAtDesktop } from './shared.styles';
import {
  Header, Title, ModificaButton, CompactSummary, InfoList, InfoRow,
} from './VehicleSummaryCard.styles';
import editIcon from '../../../../../assets/redesign_icons/edit-icon.svg';

function MotoSummaryCard({ insuranceRequest, modificaDati }) {
  const [detailsOpen, setDetailsOpen] = useState(false);
  const { moto, customer } = insuranceRequest;

  const contraente = customer.gender !== 'G'
    ? `${customer.name} ${customer.surname}`
    : customer.business_name;

  return (
    <Card>
      <Header>
        <Title>
          Moto
          {' '}
          <b>{moto.moto_plate}</b>
        </Title>
        {modificaDati && (
          <ModificaButton type="button" onClick={modificaDati}>
            Modifica Dati
            <img src={editIcon} alt="" />
          </ModificaButton>
        )}
      </Header>

      <CompactSummary>
        {moto.brand.name}
        {' '}
        {moto.model.name}
      </CompactSummary>

      <AlwaysOpenAtDesktop>
        <CollapsiblePanel
          open={detailsOpen}
          onToggle={() => setDetailsOpen((open) => !open)}
          instructionText=""
          openLabel="Nascondi dettagli"
          closedLabel="Dettagli moto"
        >
          <InfoList>
            <InfoRow>
              <dt>Contraente</dt>
              <dd>{contraente}</dd>
            </InfoRow>
            <InfoRow>
              <dt>Marca</dt>
              <dd>{moto.brand.name}</dd>
            </InfoRow>
            <InfoRow>
              <dt>Modello</dt>
              <dd>{moto.model.name}</dd>
            </InfoRow>
            <InfoRow>
              <dt>Targa</dt>
              <dd>{moto.moto_plate}</dd>
            </InfoRow>
            <InfoRow>
              <dt>Inizio Copertura</dt>
              <dd>{moment(insuranceRequest.policy_effective_date).format('DD-MM-YYYY')}</dd>
            </InfoRow>
          </InfoList>
        </CollapsiblePanel>
      </AlwaysOpenAtDesktop>
    </Card>
  );
}

export default MotoSummaryCard;
